import { $ } from "../../third-party-imports";
import { getBlogRow } from "./getBlogRow";

export function createArticleList(g2Data: any)
{
    const blogs: any[] = g2Data.response.docs;
    const blogWrapperOne = $('.blog_wrapper.one');
    const blogWrapperTwo = $('.blog_wrapper.two');
    blogs.forEach((blog, i) =>
    {
        const row = getBlogRow(blog, i);
        if (i < 3)
        {
            blogWrapperOne.append(row);
        } else
        {
            blogWrapperTwo.append(row);
        }
    });
}
